import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom";
import App from "./App";
import store from "./redux/store";
import * as serviceWorker from "./serviceWorker";
import "./assets/scss/App.scss";

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register({
    onUpdate: installingWorker => {
        setTimeout(() => {
            const { dispatch } = store;
            dispatch({ type: "APP_HAS_UPDATE", payload: { hasUpdate: true } });
        }, 1000);
    }
});
